import React, { useLayoutEffect, useRef } from "react";
import { Container } from "react-bootstrap";
import { useLocation } from "react-router-dom";

type Props = {
  children: React.ReactNode;
};

const Main: React.FC<Props> = ({ children }) => {
  const { pathname } = useLocation();

  const topDivRef = useRef<HTMLDivElement | null>(null);

  useLayoutEffect(() => {
    topDivRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [pathname]);

  return (
    <main className="main-container" ref={topDivRef}>
      <Container fluid={true} className="px-0">
        {children}
      </Container>
    </main>
  );
};

export default Main;
